import { Stack, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	title: string;
	children: ReactNode;
};

export const ProfileSection: FC<Props> = ({ title, children }) => {
	const theme = useTheme();

	return (
		<Stack mt={0.8}>
			<Typography
				variant="overline"
				color={theme.palette.grey[500]}
				px={1.6}
				pt={2.4}
				pb={0.8}
			>
				{title}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>{children}</Stack>
		</Stack>
	);
};
